import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ProductEnvironmentSimpleAttribute } from "@hermes/api-model-product-environment";

import {
    filterUnwantedValue,
    getAttributeDataFirstValue,
} from "../../../helpers/agec-helper";

@Component({
    selector: "h-recyclability-attribute",
    templateUrl: "./recyclability-attribute.component.html",
    styleUrls: ["./recyclability-attribute.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecyclabilityAttributeComponent implements OnChanges, OnDestroy {
    @Input({ required: true })
    public recyclabilityAttributes: ProductEnvironmentSimpleAttribute[] = [];

    public recyclabilityTexts: string[] = [];

    private subscriptions: Subscription = new Subscription();

    private recyclabilityAttributeTransformer: Record<
        string,
        (attribute: ProductEnvironmentSimpleAttribute) => string | undefined
    > = {
        PRODUCT_RECYCLABILITY: (attribute) =>
            this.getProductRecyclability(attribute),
        PRODUCT_RECYCLABILITY_PACKAGING_PERFUME: (attribute) =>
            this.getProductRecyclability(attribute),
        PRODUCT_RECYCLABILITY_PACKAGING: (attribute) =>
            this.getProductRecyclability(attribute),
        REFILLABLE_PRODUCT: (attribute) => this.getProductRefillable(attribute),
    };

    public ngOnChanges(changes: SimpleChanges) {
        if (
            changes.recyclabilityAttributes &&
            changes.recyclabilityAttributes.currentValue
        ) {
            this.recyclabilityTexts = this.recyclabilityAttributes
                .map((recyclabilityAttribute) => {
                    const transformFunction =
                        this.recyclabilityAttributeTransformer[
                            recyclabilityAttribute.code
                        ];
                    return transformFunction
                        ? transformFunction(recyclabilityAttribute)
                        : undefined;
                })
                .filter(filterUnwantedValue);
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private getProductRecyclability(
        productRecyclabilityAttribute: ProductEnvironmentSimpleAttribute,
    ): string | undefined {
        const recyclabilityDataValue = getAttributeDataFirstValue(
            productRecyclabilityAttribute,
        );
        if (
            recyclabilityDataValue === "VAL_01" ||
            recyclabilityDataValue === "VAL_02"
        ) {
            return productRecyclabilityAttribute.value;
        }
        return undefined;
    }

    private getProductRefillable(
        productRefillableAttribute: ProductEnvironmentSimpleAttribute,
    ): string | undefined {
        const refillableDataValue = getAttributeDataFirstValue(
            productRefillableAttribute,
        );
        if (refillableDataValue === "VAL_164") {
            return productRefillableAttribute.value;
        }
        return undefined;
    }
}
